import React from 'react';

export const renderImportInstructions = () => (
  <ul>
    <li>File must be an Excel file (.xls/.xlsx).</li>
    <li>Row 1 must contain column headings.</li>
    <li>The second column heading in row 1 must be {'"Company Code"'}.</li>
    <li>The remaining rows must contain data for the current Company Code/Period selected.</li>
    <li>Blank rows are not allowed.</li>
    <li>Column 1 must be the adjustment Period (i.e., ADJ-17 for tax year 2018).</li>
    <li>Column 2 must be the Company Code.</li>
    <li>Column 3 must be the Account number.</li>
    <li>Column 4 must be the Currency code (i.e., USD for US Dollars).</li>
    <li>Column 5 must be the Beginning Balance.</li>
    <li>Column 6 is optional. If utilized, it must be Trading Partner.</li>
    <li>Column 7 is optional. If utilized, it must be Cost Center.</li>
    <li>Column 8 is optional. If utilized, it must be Geography.</li>
    <li>Column 9 is optional. If utilized, it must be Project Code.</li>
    <li>Column 10 is optional. If utilized, it must be Reference.</li>
    <li>Column 11 is optional. If utilized, it must be Book Type.</li>
    <li>Column 12 is optional. If utilized, it must be Product Line.</li>
    <li>P&L accounts and zero balance accounts should not be included.</li>
  </ul>
);
